export const convertByoName = (name: any, size: any, isByo: any) => {
    if(isByo) {
        return name
    } else {
        return `${name} ${size?size:""}`
    }
}